import {
    REPRESENTATIVE,
    FETCH_ALL_REPRESENTATIVES,
    SET_REPRESENTATIVES,
    DELETE_REPRESENTATIVE,
    INSERT_REPRESENTATIVE,
    PUT_REPRESENTATIVE,
    setRepresentatives,
    FETCH_CUSTOMER_REPRESENTATIVES,
    FETCH_COMPANY_REPRESENTATIVES,
    UPDATE_REPRESENTATIVE,
    putRepresentative,
} from "../../actions/RepresentativesActions";
import {
    API_CALL_ERROR,
    API_CALL_SUCCESS,
    apiRequest,
    GET, PUT
} from "../../actions/ApiCallsActions";
import {
    addNotification
} from "../../actions/NotificationActions";
import endpoints from "../../../endpoints";

export default ({dispatch}) => next => async action => {
    next(action);

    if (!action.payload) return;
    const {type, payload} = action;

    switch (type) {
        case FETCH_ALL_REPRESENTATIVES: {
            const url = endpoints.representatives();
            dispatch(apiRequest(url, GET, REPRESENTATIVE));
            break
        }
        case FETCH_CUSTOMER_REPRESENTATIVES: {
            const {meta} = payload;
            const url = endpoints.customerRepresentatives(meta.companyId, meta.customerId);
            dispatch(apiRequest(url, GET, REPRESENTATIVE));
            break
        }
        case FETCH_COMPANY_REPRESENTATIVES: {
            const {meta} = payload;
            const url = endpoints.companyRepresentatives(meta.companyId);
            dispatch(apiRequest(url, GET, REPRESENTATIVE));
            break
        }
        case `${REPRESENTATIVE} ${API_CALL_SUCCESS}` : {
            const {data} = payload;
            dispatch(setRepresentatives(data));
            break
        }
        case `${REPRESENTATIVE} ${API_CALL_ERROR}` : {
            addNotification("Failed to get representatives", "error");
            break
        }
        case `${UPDATE_REPRESENTATIVE}` : {
            const {meta, data} = payload;
            const url = endpoints.representative(meta.companyId, meta.customerId, meta.repId);
            const config = {
                headers: {
                    "Content-Type": "application/json"
                }
            };

            dispatch(apiRequest(url, PUT, UPDATE_REPRESENTATIVE, data, config));
            break
        }
        case `${UPDATE_REPRESENTATIVE} ${API_CALL_SUCCESS}`: {
            const {data} = payload;

            dispatch(putRepresentative(data));
            addNotification("Representative Updated", "success");
            break
        }
        case `${UPDATE_REPRESENTATIVE} ${API_CALL_ERROR}`: {
            addNotification("Failed to updated representative", "error");
            break
        }

    }
}
